// extracted by mini-css-extract-plugin
module.exports = {"btn":"BigPlayButton_btn__2Kfm_","icon":"BigPlayButton_icon__1JFFS","hidden":"BigPlayButton_hidden__2dfRW"};